import React from "react";
import Styles from "../styles/Styles";
import { Avatar, Grid } from "@material-ui/core";
import {
  CustomText,
  IconButtonContained,
  IconsBase64,
  Table,
} from "../../../components";
import { Colors, fonts, Texts } from "../../../config";
import { Clear, Place, Style } from "@material-ui/icons";
import { hooks, masks, SessionStorage } from "../../../utils";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import { customModal, errorModal } from "../../../components/modals/utils";
import { api } from "../../../services";
import ResponseError from "../../../services/helpers/ResponseError";

const DrawListPreservedAreasCards = (dataList, reloadList) => {
  const texts = Texts["pt-BR"].Main.UsersStatement;
  const { loading, call } = hooks.useRequest();
  const acceptRefund = (refundId: string) => {
    const refund = dataList.find((item) => item.id === refundId);
    const paymentId = refund.transaction.id;

    errorModal.setInfos("Carregando", ["aguarde..."], null, null);
    call(null, api.getPaymentLink(paymentId), (data) => {
      if (data.ok) {
        window.open(data.data.invoiceUrl, "_blank");
        customModal.setInfos(
          "Sucesso!",
          [],
          {
            onClick: () => window.open(data.data.invoiceUrl, "_blank"),
            label: "Ir ao Site",
          },
          null,
          <div style={{ paddingInline: "22px", paddingBlock: "16px" }}>
            <CustomText>
              Processo para o estorno iniciado. Redirecionando para:
            </CustomText>
            <CustomText
              textColor="blue"
              style={{ textDecoration: "underline", paddingTop: "12px" }}
            >
              <a href={data?.data?.invoiceUrl} target="_blank">
                {data?.data?.invoiceUrl}
              </a>
            </CustomText>
          </div>
        );
      } else {
        const errorResponse = new ResponseError(data);
        errorResponse.alertMessage();
      }
    });
  };

  const denyRefund = (refundId: string) => {
    errorModal.setInfos("Carregando", ["aguarde..."], null, null);
    call(null, api.denyRefund(refundId), (data) => {
      if (data.ok) {
        reloadList();
      } else {
        const errorResponse = new ResponseError(data);
        errorResponse.alertMessage();
      }
    });
  };

  const paymentMethod = (method: string) => {
    if (method === "BILLET") {
      return "Boleto";
    } else if (method === "PIX") {
      return "PIX";
    } else if (method === "CREDIT_CARD") {
      return "Cartão de Crédito";
    } else if (method === "DEBIT_CARD") {
      return "Cartão de Débito";
    } else {
      return null;
    }
  };

  const modalList = (data: any) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {data?.map((item) => {
          return (
            <Styles.ListItemM>
              <Styles.ListTextM $label>{item.label}</Styles.ListTextM>
              <Styles.ListTextM>{item.value}</Styles.ListTextM>
            </Styles.ListItemM>
          );
        })}
      </div>
    );
  };

  const Status = (data?: string) => {
    if (data === "OVERDUE") {
      return (
        <Styles.StatusContainer $disabled>Atrasado</Styles.StatusContainer>
      );
    } else if (data === "PENDING") {
      return (
        <Styles.StatusContainer $disabled>Pendente</Styles.StatusContainer>
      );
    } else if (data === "REJECTED") {
      return (
        <Styles.StatusContainer $disabled>Rejeitado</Styles.StatusContainer>
      );
    } else if (data === "INACTIVE") {
      return <Styles.StatusContainer $disabled>Inativo</Styles.StatusContainer>;
    } else if (data === "PAID" || data === "ACCEPTED") {
      return <Styles.StatusContainer>Estornado</Styles.StatusContainer>;
    } else if (data === "PROCESSING") {
      return (
        <Styles.StatusContainer $disabled>Em andamento</Styles.StatusContainer>
      );
    }
  };

  const modalContent = (idDeposity: string, isPending: boolean, item: any) => {
    let data = [
      {
        label: "Nome",
        value: item?.transaction?.user?.name,
      },
      {
        label: "CPF",
        value: masks.CPF(item?.transaction?.user?.cpf),
      },
      {
        label: "E-mail",
        value: item?.transaction?.user?.email,
      },
      {
        label: "Data",
        value: masks.formatDate(item?.createdAt.split("T")[0]),
      },
      {
        label: "N° Pedido",
        value: item?.transaction?.asaasId
          ? item?.transaction?.asaasId
          : "Dado não encontrado",
      },
      {
        label: "Forma de Pagamento",
        value: item?.transaction
          ? paymentMethod(item?.transaction?.method)
          : "Dado não encontrado",
      },
      {
        label: "Status",
        value: Status(item?.status),
      },
      {
        label: "Dado Total",
        value: item?.transaction?.value?.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        }),
      },
      {
        label: "Motivo",
        value: item?.motive ? item?.motive : "Sem Motivo",
      },
    ];

    return (
      <>
        <Styles.DeposityModalContainer>
          <Styles.DeposityModalTitle>Estorno</Styles.DeposityModalTitle>
          <Styles.DeposityModalContent>
            {modalList(data)}
          </Styles.DeposityModalContent>
          <div
            style={{
              marginTop: 20,
            }}
          >
            {isPending ? (
              <>
                <Styles.DeposityModalButtons>
                  <Styles.ApproveButton
                    startIcon={<CheckIcon />}
                    onClick={() => {
                      acceptRefund(idDeposity);
                    }}
                  >
                    Aprovar
                  </Styles.ApproveButton>
                  <Styles.DisapproveButton
                    startIcon={<CloseIcon />}
                    onClick={() => {
                      denyRefund(idDeposity);
                    }}
                  >
                    Negar
                  </Styles.DisapproveButton>
                  <Styles.CloseButton onClick={customModal.close}>
                    Fechar
                  </Styles.CloseButton>
                </Styles.DeposityModalButtons>
              </>
            ) : (
              <>
                <Styles.CloseButton onClick={customModal.close}>
                  Fechar
                </Styles.CloseButton>
              </>
            )}
          </div>
        </Styles.DeposityModalContainer>
      </>
    );
  };

  const seeDeposity = (idDeposity: string, isPending: boolean, item: any) => {
    customModal.setInfos(
      "",
      [""],
      null,
      null,
      modalContent(idDeposity, isPending, item),
      true,
      null
    );
  };
  return (
    <>
      <Table
        id="DepositsTable"
        data={dataList}
        headers={texts.headerTableHome}
        lastAlign={false}
        firstColumn={false}
        renderItemColumns={(item) => [
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ margin: 0 }}>{item.transaction?.user?.email}</p>
            <p style={{ margin: 0 }}>
              {masks.CPF(item.transaction?.user?.cpf)}
            </p>
          </div>,

          item.transaction?.value?.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
          item.transaction?.method ? (
            <p style={{ margin: 0, fontFamily: fonts.bold }}>
              {paymentMethod(item.transaction?.method)}
            </p>
          ) : (
            <p style={{ fontFamily: fonts.bold }}>Dado não encontrado</p>
          ),
          <Styles.AreaButtonsTable>
            <>
              {item.status === "PENDING" ? (
                <>
                  <IconButtonContained
                    loading={loading}
                    disabled={loading}
                    changeColor={Colors.blue}
                    Icon={<MdOutlineRemoveRedEye />}
                    changeIconColor={Colors.white}
                    onClick={() =>
                      seeDeposity(item?.id, item.status === "PENDING", item)
                    }
                  />
                  <IconButtonContained
                    loading={loading}
                    disabled={loading}
                    changeColor={Colors.green}
                    Icon={<CheckIcon />}
                    changeIconColor={Colors.white}
                    onClick={() => acceptRefund(item?.id)}
                  />
                  <IconButtonContained
                    loading={loading}
                    disabled={loading}
                    changeColor={Colors.red}
                    Icon={<Clear />}
                    changeIconColor={Colors.white}
                    onClick={() => denyRefund(item?.id)}
                  />
                </>
              ) : (
                <>
                  <IconButtonContained
                    loading={loading}
                    disabled={loading}
                    changeColor={Colors.blue}
                    Icon={<MdOutlineRemoveRedEye />}
                    changeIconColor={Colors.white}
                    onClick={() => seeDeposity(item?.id, false, item)}
                  />
                </>
              )}
            </>
          </Styles.AreaButtonsTable>,
        ]}
      />
    </>
  );
};
function formatarDataHora(dataString: string): string {
  const data = new Date(dataString);

  if (isNaN(data.getTime())) {
    throw new Error("Data inválida");
  }

  const dia = String(data.getDate()).padStart(2, "0");
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const hora = String(data.getHours()).padStart(2, "0");
  const minutos = String(data.getMinutes()).padStart(2, "0");

  return `${dia}/${mes} ${hora}:${minutos}`;
}
const DrawListRecentSalesCards = (list) => {
  const UserData = SessionStorage.getItem("data");

  return list.map((item) => {
    return (
      <>
        <Styles.ListItem>
          <Styles.LeftGroup>
            <Avatar
              alt={UserData?.firstName}
              src={`data:image/png;base64, ${item?.img}`}
            />
            <Styles.UserName>{item?.user?.name}</Styles.UserName>
          </Styles.LeftGroup>

          <hr />
          {/* <Styles.Line/> */}

          <Styles.rightGroup>
            <div style={{ display: "flex", flexDirection: "row", gap: 5 }}>
              <Styles.iconCotnainer>
                <Styles.Icon alt="" src={IconsBase64.creditCard} />
              </Styles.iconCotnainer>
              <Styles.textArea>
                <Styles.Title $customFontSize>{item?.billingType}</Styles.Title>
                <Styles.text $customText>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Grid item>{"Cotação: "}</Grid>
                    <Grid item>
                      {item?.valueUnit?.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </Grid>
                  </div>
                  <div
                    style={{
                      fontWeight: 700,
                      marginLeft: "2px",
                      color: Colors.black,
                    }}
                  >
                    {item?.price?.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </div>
                </Styles.text>
              </Styles.textArea>
            </div>
            <Styles.textArea>
              <Styles.Title $customFontSize>
                {" "}
                {item?.value?.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </Styles.Title>
              <Styles.text $customText>
                {formatarDataHora(item?.createdAt)}
              </Styles.text>
            </Styles.textArea>
          </Styles.rightGroup>
        </Styles.ListItem>
        <Styles.Line />
      </>
    );
  });
};

export { DrawListPreservedAreasCards, DrawListRecentSalesCards };
